window.initDessertModal = () => {
    const modaleDessert = document.getElementById('modal-showModalDessert');

    function updatePrice(item, price) {
        if (item != ('' && null)) {
            let quantity = modaleDessert.querySelector('.quantity').getAttribute('data-quantity');
            Alpine.store('dessertModal').updateDessert(item, price, quantity);
        }
    }

    if (modaleDessert != (undefined && null)) {
        const desserts = modaleDessert.querySelectorAll('.item-dessert');
        const formats = modaleDessert.querySelectorAll('.dessert-format');
        const resultPrice = document.getElementById('priceDrinkDessert');

        let item = '';
        let price = '';

        //clean price before choose
        const cleanPrice = () => {
            price = '';
            item = '';
            resultPrice.innerHTML = "";
            resultPrice.classList.remove('mr-2');
            Alpine.store('dessertModal').cleanDessert();
        }

        cleanPrice();

        //formats
        for (let i = 0; i < formats.length; i++) {
            formats[i].addEventListener('click', itemFormat => {
                //toggle active class on click format
                if (!formats[i].classList.contains('active') && !formats[i].classList.contains('disabled')) {
                    formats[i].classList.add('active');

                    formats.forEach((formatDessert, index) => {
                        if (index != i) {
                            formats[index].classList.remove('active');
                        }
                    });

                    item = formats[i].getAttribute('data-item-id');
                    price = formats[i].getAttribute('data-price');

                    updatePrice(item, price);
                } else {
                    item = "";
                    price = "";
                    formats[i].classList.remove('active');
                    Alpine.store('dessertModal').cleanDessert();
                }
            })

            //on cart edition data
            if (formats[i].classList.contains('active')) {
                item = formats[i].getAttribute('data-item-id');
                price = formats[i].getAttribute('data-price');

                updatePrice(item, price);
            }
        }

        //deserts
        for (const dessert of desserts) {
            dessert.addEventListener('click', () => {
                let nbDessertFormat = 0;
                let initActiveFormat = null;

                //toggle active class on click dessert
                if (!dessert.classList.contains('active')) {
                    desserts.forEach((itemDessert, index) => {
                        desserts[index].classList.remove('active');
                    });

                    formats.forEach((itemFormat, index) => {
                        if(dessert.id === formats[index].dataset.flavour && nbDessertFormat < 1) {
                            nbDessertFormat++;
                            initActiveFormat = formats[index];
                        }
                        formats[index].classList.remove('active');
                    });

                    cleanPrice();
                    dessert.classList.add('active');

                    //Select first format on dessert selection
                    initActiveFormat.dispatchEvent(new Event('click'));
                }
            })
        }
    }
}

window.initDrinkModal = () => {
    const modaleDrink = document.getElementById('modal-showModalDrink');

    function updatePrice(item, price) {
        if (item != ('' && null)) {
            let quantity = modaleDrink.querySelector('.quantity').getAttribute('data-quantity');
            Alpine.store('drinkModal').updateDrink(item, price, quantity);
        }
    }

    if (modaleDrink != (undefined && null)) {
        const drinks = modaleDrink.querySelectorAll('.item-drink');
        const resultPrice = document.getElementById('priceDrinkDessert');

        let item = '';
        let price = '';

        //clean price before choose
        resultPrice.innerHTML = "";
        resultPrice.classList.remove('mr-2');

        //deserts
        for (let i = 0; i < drinks.length; i++) {
            drinks[i].addEventListener('click', drink => {
                //toggle active class on click drink
                if (!drinks[i].classList.contains('active') && !drinks[i].classList.contains('disabled')) {
                    drinks[i].classList.add('active');

                    drinks.forEach((itemDrink, index) => {
                        if (index != i) {
                            drinks[index].classList.remove('active');
                        }
                    });

                    item = drinks[i].getAttribute('data-item-id');
                    price = drinks[i].getAttribute('data-price');

                    updatePrice(item, price);
                }
            })

            //on cart edition data
            if (drinks[i].classList.contains('active')) {
                item = drinks[i].getAttribute('data-item-id');
                price = drinks[i].getAttribute('data-price');

                updatePrice(item, price);
            }
        }
    }
}

window.calculatePriceDrinkDessert = (quantity, type) => {
    if (type == 'dessert') {
        Alpine.store(type + 'Modal').quantityStore = quantity;
    }

    const modal = (type == 'dessert') ? document.getElementById('modal-showModalDessert') : document.getElementById('modal-showModalDrink')
    const resultPrice = modal.querySelector('#priceDrinkDessert');

    let price = (type == 'dessert') ? Alpine.store('dessertModal').dessertStore.price : Alpine.store('drinkModal').drinkStore.price;
    let newPrice = 0;

    if (price != (undefined && null && 0)) {
        newPrice = parseFloat(price) * quantity;

        resultPrice.innerHTML = new Intl.NumberFormat('fr-FR', {
            style: 'currency',
            currency: 'EUR'
        }).format(newPrice)

        resultPrice.classList.add('mr-2');
    } else {
        resultPrice.innerHTML = "";
    }
}